import { queryExtendedBookings as universalQueryExtendedBookings, } from './bookings-reader-v2-extended-booking-extended-bookings.universal';
export const __metadata = { PACKAGE_NAME: '@wix/bookings' };
export function queryExtendedBookings(httpClient) {
    return (query, options) => universalQueryExtendedBookings(query, options, 
    // @ts-ignore
    { httpClient });
}
export { Actor, AttendanceStatus, BookingFeeStatus, BookingStatus, IdentityType, LocationType, MultiServiceBookingType, PaymentStatus, Platform, SelectedPaymentOption, SortOrder, ValueType, } from './bookings-reader-v2-extended-booking-extended-bookings.universal';
//# sourceMappingURL=bookings-reader-v2-extended-booking-extended-bookings.public.js.map